import cn from 'classnames';
import styles from './StepIndicator.module.scss';

export interface StepIndicatorProps {
  color: 'error' | 'warning' | 'success' | 'excellent';
  numberSteps: number;
  stepStyle?: 'rectangle' | 'circle';
  actualStep?: number;
}

export const StepIndicator = ({
  numberSteps,
  stepStyle,
  actualStep,
  color,
}: StepIndicatorProps) => {
  const renderSteps = () => {
    const steps = [];
    for (let i = 0; i < numberSteps; i += 1) {
      steps.push(
        <li
          key={i}
          className={cn(
            styles[stepStyle],
            styles[i < actualStep ? 'active' : ''],
            styles[color]
          )}
        />
      );
    }
    return steps;
  };

  return <ul className={styles['steps-root']}>{renderSteps()}</ul>;
};

StepIndicator.defaultProps = {
  stepStyle: 'rectangle',
  actualStep: 0,
};
